import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './JasminGin.css';
import { t, getLangFromPath, tObject, Lang } from '../utils/i18n';

const JASMIN_IMAGES = [
  '/images/blog/jasmin/jasmin-1.jpeg',
  '/images/blog/jasmin/jasmin-2.jpeg',
  '/images/blog/jasmin/jasmin-3.jpeg',
  '/images/blog/jasmin/jasmin-4.jpeg',
  '/images/blog/jasmin/jasmin-5.jpeg',
  '/images/blog/jasmin/jasmin-6.jpeg',
  '/images/blog/jasmin/jasmin-7.jpeg',
];

const JasminGin: React.FC = () => {
  const location = useLocation();
  const [lang, setLang] = useState<string>('en');

  useEffect(() => {
    setLang(getLangFromPath(location.pathname, 'en'));
  }, [location.pathname]);

  const paragraphs = (tObject(lang as Lang, 'jasminGin.paragraphs') ||
    tObject('en', 'jasminGin.paragraphs') ||
    []) as string[];

  return (
    <div className="jasmin-gin" style={{ overflowX: 'hidden' }}>
      <section className="jasmin-content">
        <div className="jasmin-content-inner">
          <div className="jasmin-title-block">
            <h1 className="jasmin-title">{t(lang as Lang, 'jasminGin.title')}</h1>
          </div>

          <div className="jasmin-hero-image">
            <img
              src="/images/blog/jasmin/hero.jpeg"
              alt={t(lang as Lang, 'jasminGin.heroAlt')}
              loading="eager"
              decoding="async"
            />
          </div>

          <div className="jasmin-body">
            {paragraphs.map((p, idx) => (
              <p key={idx}>{p}</p>
            ))}
          </div>
        </div>
      </section>

      <section className="jasmin-gallery">
        <div className="jasmin-gallery-grid">
          {JASMIN_IMAGES.map((src, idx) => (
            <div key={src} className="jasmin-gallery-item">
              <img
                src={src}
                alt={`${t(lang as Lang, 'jasminGin.title')} ${idx + 1}`}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default JasminGin;
